import { RoomApiRoomUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useRoomUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: RoomApiRoomUpdateRequest, config) =>
      appApiClient.roomApi.roomUpdate(req, config),
  });
